import { InjectionToken } from '@angular/core';

export const SESSION_ID = new InjectionToken<string>('Session id');
